<template>
    <div class="login-page">
        <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions"
            @close="noticeVisible = false" />

        <Mytitle :use-background="false" :text-color="'black'" :padding="'20px 11%'" />

        <section class="hero-wrap">
            <div class="hero-panel">
                <div class="hero-copy">
                    <p class="eyebrow">考试报名入口</p>
                    <h1>统一报名 · 身份核验 · 进度查询</h1>
                    <p>
                        面向考生提供正式、清晰、可信的登录入口，集中展示报名通知、系统公告与关键报名信息。
                    </p>
                    <div class="hero-badges">
                        <span>安全登录</span>
                        <span>官方公告</span>
                        <span>报名查询</span>
                    </div>
                </div>

                <div class="hero-grid">
                    <div class="banner-card">
                        <div class="carousel">
                            <div class="carousel-wrapper" :style="carouselStyle">
                                <div v-for="(item, index) in carouselItems" :key="item.id || index" class="carousel-item"
                                    :class="{ clickable: item.link }" @click="handleCarouselClick(item)">
                                    <img v-if="item.image || item.image_url"
                                        :src="resolveUrl(item.image_url || item.image)" alt="轮播图" class="carousel-img" />
                                    <div v-else class="carousel-placeholder">
                                        <strong>{{ item.title || '欢迎使用考试报名系统' }}</strong>
                                        <span>请关注最新通知与报名安排</span>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-indicators">
                                <span v-for="(item, index) in carouselItems" :key="item.id || index"
                                    :class="['indicator', { active: currentIndex === index }]"
                                    @click="currentIndex = index"></span>
                            </div>
                        </div>
                    </div>

                    <aside class="login-card">
                        <div class="login-head">
                            <span class="login-tag">官方登录</span>
                            <h2>账号登录</h2>
                            <p>请输入账号信息后进入报名系统</p>
                        </div>

                        <div class="security-note">
                            <span class="security-dot"></span>
                            登录信息仅用于身份验证，请妥善保管账号密码。
                        </div>

                        <form class="login-form" @submit.prevent="Home">
                            <label for="username">用户名</label>
                            <input id="username" type="text" v-model.trim="username" placeholder="请输入用户名" autocomplete="username" required>

                            <label for="password">密码</label>
                            <input id="password" type="password" v-model="password" placeholder="请输入密码" autocomplete="current-password" required>

                            <button class="submit-btn" :disabled="submitting" type="submit">
                                {{ submitting ? '登录中...' : '登录系统' }}
                            </button>
                        </form>

                        <div class="login-links">
                            <a href="#" @click="goToRegister">新用户注册</a>
                            <span>｜</span>
                            <a href="#" @click="goToForgotPassword">忘记密码</a>
                        </div>
                    </aside>
                </div>
            </div>
        </section>

        <section class="notice-section">
            <div class="notice-header">
                <div class="notice-title">
                    <img :src="labaImage" class="notice-icon" alt="公告" />
                    <span>通知公告</span>
                </div>
                <p>查看最新报名须知、系统通知和重要提醒。</p>
            </div>

            <ul class="notice-list">
                <li v-for="item in visibleAnnouncements" :key="item.id" class="notice-item">
                    <div class="item">
                        <div class="image">
                            <img :src="labaImage" alt="小喇叭" class="horn-icon" />
                        </div>
                        <div class="text" @click="openAnnouncement(item.id)">
                            {{ item.title }}
                        </div>
                    </div>
                </li>
            </ul>

            <div class="announcement-pagination" v-if="annPageCount > 1">
                <button class="page-btn prev-btn" :disabled="annPage === 0" @click="goToPrevPage"
                    :class="{ disabled: annPage === 0 }" title="上一页">
                    ‹
                </button>
                <div class="page-info">
                    <span class="current-page">{{ annPage + 1 }}</span>
                    <span class="separator">/</span>
                    <span class="total-pages">{{ annPageCount }}</span>
                </div>
                <button class="page-btn next-btn" :disabled="annPage >= annPageCount - 1" @click="goToNextPage"
                    :class="{ disabled: annPage >= annPageCount - 1 }" title="下一页">
                    ›
                </button>
            </div>
        </section>

        <PublicSiteFooter service-phone="13301146687" />
    </div>
</template>
<script>
// 导入laba.png图片
import labaImage from '../assets/laba.png';
import Mytitle from '../assets/title.vue'
import NoticeBar from './NoticeBar.vue'
import PublicSiteFooter from './PublicSiteFooter.vue'
import * as authApi from '@/api/auth';
import { api } from '@/utils/api';
export default {
    name: 'Login',
    components: {
        Mytitle,
        NoticeBar,
        PublicSiteFooter
    },
    // 声明自定义事件
    emits: ['switch-to-register', 'switch-to-home'],
    data() {
        return {
            labaImage,
            username: '',
            password: '',
            email: 'xxxxxxxxxxxxx',
            currentIndex: 0,
            timer: null,
            timeTimer: null,
            carouselItems: [],
            announcements: [],
            annPage: 0,
            noticeVisible: false,
            noticeMessage: '',
            noticeType: 'info',
            noticeActions: [],
            submitting: false
        }
    },
    computed: {
        carouselStyle() {
            return {
                transform: `translateX(-${this.currentIndex * 100}%)`,
                transition: 'transform 0.5s ease'
            }
        },
        visibleAnnouncements() {
            const start = this.annPage * 5
            return (Array.isArray(this.announcements) ? this.announcements : []).slice(start, start + 5)
        },
        annPageCount() {
            const len = Array.isArray(this.announcements) ? this.announcements.length : 0
            return Math.ceil(len / 5)
        }
    },
    mounted() {
        this.fetchCarousel();
        this.fetchAnnouncements();
    },
    beforeUnmount() {
        // 组件卸载时清除定时器
        if (this.timeTimer) {
            clearInterval(this.timeTimer);
        }
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        async Home(event) {
            // 阻止表单默认提交行为
            event.preventDefault();
            
            // 防止重复提交
            if (this.submitting) return
            
            try {
                if (!this.username || !this.password) {
                    this.noticeMessage = '请输入用户名和密码'
                    this.noticeType = 'warning'
                    this.noticeActions = []
                    this.noticeVisible = true
                    setTimeout(() => { this.noticeVisible = false }, 2500)
                    return;
                }
                
                this.submitting = true
                // 调用后端登录接口
                await authApi.login({ username: this.username.trim(), password: this.password });
                // 登录成功，切换到首页
                this.$emit('switch-to-home');
            } catch (err) {
                const msg = err?.response?.data?.detail || err?.response?.data?.non_field_errors?.[0] || '登录失败，请检查用户名或密码';
                this.noticeMessage = msg
                this.noticeType = 'error'
                this.noticeActions = []
                this.noticeVisible = true
                setTimeout(() => { this.noticeVisible = false }, 2500)
            } finally {
                this.submitting = false
            }
        },
        startCarousel() {
            const len = this.carouselItems.length || 1;
            this.timer = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % len;
            }, 4000);
        },

        async fetchCarousel() {
            try {
                const data = await api.get('/api/admin/carousel/public/');
                this.carouselItems = Array.isArray(data) ? data : [];
                // 若无数据，使用占位
                if (this.carouselItems.length === 0) {
                    this.carouselItems = [{ title: '欢迎使用考试报名系统' }];
                }
                // 启动轮播
                this.startCarousel();
            } catch (e) {
                console.error(e);
                this.carouselItems = [{ title: '欢迎使用考试报名系统' }];
                this.startCarousel();
            }
        },

        resolveUrl(path) {
            if (!path) return '';
            // 后端已返回相对路径（/media/...），保持相对引用，避免跨设备localhost问题
            if (path.startsWith('http')) return path;
            return path.startsWith('/') ? path : `/${path}`;
        },

        // 轮播图点击跳转
        handleCarouselClick(item) {
            if (!item.link) return;
            let link = item.link.trim();
            // 判断是否为外部链接（包含域名但没有协议前缀的情况）
            if (link.startsWith('http://') || link.startsWith('https://')) {
                window.open(link, '_blank');
            } else if (link.startsWith('#')) {
                // 内部哈希路由
                window.location.hash = link.substring(1);
            } else if (link.includes('.') && !link.startsWith('/')) {
                // 包含点号且不是相对路径，可能是域名如 www.baidu.com，自动补全协议
                window.open('https://' + link, '_blank');
            } else {
                // 其他情况当作相对路径处理
                window.location.href = link;
            }
        },

        goToRegister(event) {
            // 阻止<a>标签的默认行为
            event.preventDefault();
            // 触发自定义事件，通知父组件(App.vue)切换到注册页面
            this.$emit('switch-to-register');
        },
        goToForgotPassword(event) {
            // 阻止<a>标签的默认行为
            event.preventDefault();
            // 使用哈希路由跳转到忘记密码页面
            window.location.hash = 'forgot-password';
        },

        // 改为绑定二级目录公开列表（例如：报考文件/须知 -> baokao）
        async fetchAnnouncements() {
            try {
                const sectionKey = 'baokao';
                const res = await fetch(`/api/admin/section/public/?section=${encodeURIComponent(sectionKey)}`);
                const data = await res.json();
                this.announcements = Array.isArray(data) ? data : (data.results || []);
            } catch (e) {
                console.error('获取二级目录公开列表失败', e);
            }
        },
        // 点击进入二级目录详情
        openAnnouncement(id) {
            if (!id) return;
            // 记录来源页为登录页
            try { sessionStorage.setItem('last_page', window.location.hash || '#login') } catch (e) { }
            window.location.hash = `section/${id}`;
        },
        // 翻页功能
        goToPrevPage() {
            if (this.annPage > 0) {
                this.annPage--;
            }
        },
        goToNextPage() {
            if (this.annPage < this.annPageCount - 1) {
                this.annPage++;
            }
        }
    }
}
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at top left, rgba(37, 99, 235, 0.08), transparent 24%),
        radial-gradient(circle at top right, rgba(14, 165, 233, 0.08), transparent 22%),
        linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
}

.hero-wrap {
    width: min(1440px, calc(100% - 32px));
    margin: 10px auto 0;
}

.hero-panel {
    border-radius: 28px;
    padding: 24px;
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(148, 163, 184, 0.2);
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(12px);
}

.hero-copy {
    margin-bottom: 20px;
}

.eyebrow {
    margin: 0 0 10px;
    color: #2563eb;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.hero-copy h1 {
    margin: 0;
    color: #0f172a;
    font-size: clamp(28px, 3vw, 42px);
    line-height: 1.1;
}

.hero-copy p {
    max-width: 720px;
    margin: 12px 0 0;
    color: #475569;
    font-size: 15px;
    line-height: 1.75;
}

.hero-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 16px;
}

.hero-badges span {
    display: inline-flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 999px;
    background: rgba(37, 99, 235, 0.08);
    color: #1d4ed8;
    font-size: 13px;
    font-weight: 600;
}

.hero-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(320px, 0.9fr);
    gap: 20px;
    align-items: stretch;
}

.banner-card,
.login-card {
    border-radius: 24px;
    overflow: hidden;
}

.banner-card {
    min-height: 420px;
}

.carousel {
    position: relative;
    overflow: hidden;
    border-radius: 24px;
    background: linear-gradient(180deg, #f5f7fa, #edf3fb);
    width: 100%;
    height: 100%;
    min-height: 420px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.carousel-wrapper {
    display: flex;
    height: 100%;
}

.carousel-item {
    flex: 0 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #334155;
    font-size: 24px;
    height: 100%;
}

.carousel-item.clickable {
    cursor: pointer;
}

.carousel-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 32px;
    text-align: center;
    background:
        radial-gradient(circle at top, rgba(37, 99, 235, 0.12), transparent 42%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.65), rgba(241, 245, 249, 0.9));
}

.carousel-placeholder strong {
    color: #0f172a;
    font-size: 22px;
}

.carousel-placeholder span {
    margin-top: 10px;
    color: #64748b;
    font-size: 14px;
}

.carousel-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
}

.carousel-indicators {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 10;
}

.indicator {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator.active {
    width: 24px;
    background-color: #2563eb;
}

.login-card {
    align-self: center;
    padding: 28px;
    background: rgba(255, 255, 255, 0.94);
    border: 1px solid rgba(148, 163, 184, 0.18);
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.login-head .login-tag {
    display: inline-flex;
    margin-bottom: 10px;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(37, 99, 235, 0.1);
    color: #2563eb;
    font-size: 12px;
    font-weight: 700;
}

.login-head h2 {
    margin: 0;
    color: #0f172a;
    font-size: 24px;
}

.login-head p {
    margin: 8px 0 0;
    color: #64748b;
    font-size: 14px;
}

.security-note {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
    padding: 12px 14px;
    border-radius: 14px;
    background: #f8fbff;
    border: 1px solid #e5edf7;
    color: #475569;
    font-size: 13px;
    line-height: 1.6;
}

.security-dot {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb, #38bdf8);
}

.login-form {
    display: grid;
    gap: 10px;
    margin-top: 22px;
}

.login-form label {
    color: #334155;
    font-size: 14px;
    font-weight: 600;
}

.login-form input {
    width: 100%;
    padding: 13px 14px;
    border: 1px solid #dbe4f0;
    border-radius: 14px;
    font-size: 15px;
    background: #fff;
    color: #0f172a;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-sizing: border-box;
}

.login-form input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.submit-btn {
    margin-top: 6px;
    width: 100%;
    padding: 13px 16px;
    border: 0;
    border-radius: 14px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 14px 24px rgba(37, 99, 235, 0.18);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.submit-btn:hover {
    transform: translateY(-1px);
    filter: brightness(1.02);
}

.submit-btn:disabled {
    cursor: not-allowed;
    opacity: 0.7;
    transform: none;
    box-shadow: none;
}

.login-links {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #94a3b8;
    font-size: 14px;
}

.login-links a {
    color: #2563eb;
    text-decoration: none;
}

.login-links a:hover {
    text-decoration: underline;
}

.notice-section {
    width: min(1440px, calc(100% - 32px));
    margin: 18px auto 0;
    padding: 22px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.88);
    border: 1px solid rgba(148, 163, 184, 0.18);
    box-shadow: 0 18px 46px rgba(15, 23, 42, 0.06);
}

.notice-header {
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.notice-header p {
    margin: 0;
    color: #64748b;
    font-size: 13px;
}

.notice-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
}

.notice-icon,
.horn-icon {
    width: 18px;
    height: 18px;
}

.notice-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 10px;
}

.notice-item {
    padding: 14px 16px;
    border-radius: 16px;
    border: 1px solid #e5edf7;
    background: linear-gradient(180deg, #fff, #f8fbff);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.notice-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);
}

.item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.image {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    background: rgba(37, 99, 235, 0.08);
}

.text {
    flex: 1;
    font-size: 14px;
    line-height: 1.6;
    color: #334155;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.announcement-pagination {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #e5edf7;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.page-btn {
    width: 34px;
    height: 34px;
    padding: 0;
    background: #fff;
    color: #334155;
    border: 1px solid #dbe4f0;
    border-radius: 10px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-btn:hover:not(.disabled) {
    background-color: #2563eb;
    color: #fff;
    border-color: #2563eb;
}

.page-btn.disabled {
    background-color: #f8fafc;
    color: #cbd5e1;
    cursor: not-allowed;
}

.page-info {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #64748b;
}

.current-page {
    font-weight: 700;
    color: #2563eb;
}

.footer {
    width: min(1440px, calc(100% - 32px));
    margin: 18px auto 24px;
    text-align: center;
    padding: 14px 16px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.7);
    color: #64748b;
    border: 1px solid rgba(148, 163, 184, 0.16);
}

@media (max-width: 1024px) {
    .hero-grid {
        grid-template-columns: 1fr;
    }

    .banner-card,
    .carousel {
        min-height: 320px;
    }
}

@media (max-width: 768px) {
    .hero-wrap,
    .notice-section,
    .footer {
        width: min(100%, calc(100% - 16px));
    }

    .hero-panel,
    .notice-section {
        padding: 16px;
        border-radius: 20px;
    }

    .login-card {
        padding: 20px;
    }

    .notice-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .announcement-pagination {
        gap: 10px;
    }

    .carousel,
    .banner-card {
        min-height: 240px;
    }

    .carousel-item {
        font-size: 18px;
    }

    .hero-badges,
    .login-links {
        justify-content: flex-start;
    }
}
</style>
